import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { buildAnswerFeedback } from '../server/answer-feedback.js';
import { requireAnswerableNotification } from '../server/notification-access.js';
import { resolveInterpretation } from '../server/processNotificationAnswer.js';

/**
 * Accept or reject what the model made of a free-text answer it was not confident enough to
 * apply on its own. This is the step that keeps a misreading out of SAP: below the confidence
 * gate nothing is written until someone says the reading is right.
 */
export const confirmAnswerInterpretation = registerMutation({
  type: () => String,
  operationName: 'confirmAnswerInterpretation',
  resolve: (notificationID: string, accept: boolean) => {
    return async () => {
      const handle = await requireAnswerableNotification(notificationID);
      const outcome = await resolveInterpretation(handle, accept);
      if (!accept) return 'Deutung verworfen — die Frage ist wieder offen.';
      return buildAnswerFeedback(outcome);
    };
  },
  params: [
    { name: 'notificationID', type: () => String },
    { name: 'accept', type: () => Boolean },
  ],
});
